// Tiny localStorage wrapper: preferences are nice-to-have, so every failure
// (private mode, disabled storage, SSR) falls back silently to defaults.
export function readStoredPreference(key: string): string | null {
  try {
    return typeof window === "undefined"
      ? null
      : window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStoredPreference(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage unavailable — the app keeps working with session state only.
  }
}
